import Vue from 'vue'

import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'
import '../assets/flash.scss'

const settings = {
  duration: 5000,
  newWindow: true,
  close: true,
  gravity: 'top',
  position: 'right',
  stopOnFocus: true
}

const flashMethods = {
  success (text) {
    Toastify({
      ...settings,
      ...{
        text: text,
        className: 'flash-success'
      }
    }).showToast()
  },
  error (text) {
    Toastify({
      ...settings,
      ...{
        text: text,
        className: 'flash-error'
      }
    }).showToast()
  },
  warning (text) {
    Toastify({
      ...settings,
      ...{
        text: text,
        className: 'flash-warning'
      }
    }).showToast()
  },
  info (text) {
    Toastify({
      ...settings,
      ...{
        text: text,
        className: 'flash-info'
      }
    }).showToast()
  }
}

const plugin = function (Vue, options) {
  Vue.prototype.$flash = flashMethods
  Vue.$flash = flashMethods
}

Vue.use(plugin)
